import { Component } from 'react';
import {
  isUndefined,
  isEmpty,
  isArray,
  isNull,
  compact,
  toPairs,
  trim,
  values as _values,
} from 'lodash-es';
import { to } from 'helpers';
import { validateValues } from 'helpers/validation';

export default class Form extends Component {
  state = {
    values: this.props.initialValues || {},
    errors: {},
    networkError: false,
  };

  setNestedState = (parent, child) =>
    this.setState(prevState => ({
      ...prevState,
      [parent]: { ...prevState[parent], ...child },
    }));

  handleChange = ({ key, value }) => {
    this.setNestedState('values', { [key]: value });
    this.setNestedState('errors', { [key]: '', submitErrors: '' });
  };

  handleSubmit = async e => {
    e.preventDefault();
    this.setState({ submitting: true });
    this.props.preSubmitCheck && (await this.handleBlur());

    if (
      this.props.preSubmitCheck &&
      !isEmpty(compact(_values(this.state.errors)))
    ) {
      this.setState({ submitting: false });
      return;
    }

    this.handleValidate();
  };

  clearForm = () => {
    this.setState({
      values: this.props.initialValues,
      errors: {},
      submitting: false,
    });
  };

  handleValidate = () => {
    const errors = validateValues(this.state.values);

    if (this.props.onValidate) {
      this.props.onValidate({
        errors,
        values: this.state.values,
        validate: this.handleValidateField,
        toggleSubmitting: this.toggleSubmitting,
      });
      return;
    }

    this.setState({ errors }, this.handleValidateFinished);
  };

  toggleSubmitting = bool => this.setState({ submitting: bool });

  handleValidateField = (key, error) => {
    this.setNestedState('errors', { [key]: error });
  };

  handleRenderErrors = errors => this.setState({ errors });

  handleValidateFinished = async () => {
    const { onSubmit, onResponse, request, useFormData } = this.props;
    const { errors } = this.state;
    const { values } = this.state;
    let formData;

    if (!isEmpty(errors)) {
      this.setState({ submitting: false });
      return;
    }

    toPairs(values).forEach(([key, value]) => {
      if (typeof value !== 'boolean' && !(value instanceof File)) {
        values[key] = trim(value);
      }

      if (key === 'password'){
        values[key] = value
      }
    });

    if (onSubmit) {
      onSubmit(values);
      this.setState({ submitting: false });
      return;
    }

    if (useFormData) {
      formData = new FormData();
      toPairs(values).forEach(([key, value]) => {
        formData.append(key, value);
      });
    }

    const [err, data] = await to(request(useFormData ? formData : values));

    if (!isNull(err) && !this.props.skipSubmitErrors) {
      if (isUndefined(err.response)) {
        this.setNestedState('errors', {
          submitErrors:
            'Network connection is temporary unavailable. Please try again.',
        });
        return this.setState({ submitting: false, networkError: true });
      }

      if (!err.response.data) {
        this.setState({ submitting: false });
        return;
      }

      const { message, messages } = err.response.data;

      if (messages) {
        messages.forEach(({ field, message }) => {
          this.setNestedState('errors', {
            [field]: message,
          });
        });
      }

      if (!message) {
        return this.setState({ submitting: false });
      }

      if (!isArray(message)) {
        this.setNestedState('errors', {
          submitErrors: message,
        });
      } else {
        message.forEach(({ field, message }) => {
          this.setNestedState('errors', {
            [field]: message,
          });
        });
      }

      return this.setState({ submitting: false, networkError: false });
    }
    this.setState({ networkError: false }, () =>
      onResponse(data, this.toggleSubmitting, this.clearForm)
    );
  };

  render() {
    const { className, autocomplete = 'off', children } = this.props;
    return (
      <form
        onSubmit={this.handleSubmit}
        className={className}
        autoComplete={autocomplete}
      >
        {children({
          submitting: this.state.submitting,
          errors: this.state.errors,
          values: this.state.values,
          networkError: this.state.networkError,
          onChange: this.handleChange,
          renderError: this.handleValidateField,
          renderErrors: this.handleRenderErrors,
        })}
      </form>
    );
  }
}
